import { supabase } from '../lib/supabase';

export const comingSoonService = {
  // Get coming soon settings
  async getSettings() {
    try {
      const { data, error } = await supabase?.from('coming_soon_settings')?.select('*')?.limit(1)?.single();

      if (error) {
        if (error?.code === 'PGRST116') {
          // No settings found, return default
          return {
            data: {
              is_enabled: false,
              bypass_password: '',
              title: 'Coming Soon',
              description: 'We are working hard to bring you something amazing. Stay tuned!'
            },
            error: null
          };
        }
        return { data: null, error };
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error: { message: 'Network error loading settings' } };
    }
  },

  // Update settings (admin only)
  async updateSettings(settings, userId) {
    try {
      const { data, error } = await supabase?.from('coming_soon_settings')?.upsert([{
          ...settings,
          created_by: userId,
          updated_at: new Date()?.toISOString()
        }], {
          onConflict: 'id'
        })?.select()?.single();

      return { data, error };
    } catch (error) {
      return { data: null, error: { message: 'Network error updating settings' } };
    }
  },

  // Check if coming soon mode is active
  async isComingSoonActive() {
    try {
      const { data } = await this.getSettings();
      return data?.is_enabled || false;
    } catch (error) {
      return false;
    }
  },

  // Verify bypass password
  async verifyBypassPassword(password) {
    try {
      const { data } = await this.getSettings();
      return data?.bypass_password === password;
    } catch (error) {
      return false;
    }
  }
};

export default comingSoonService;